module.exports = __webpack_public_path__ + "img/icon_account.162cc2d7.svg";